import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SectionTitle, Text } from "../../components/styledComponent";
import styles from "./style.module.scss";

const PrivacyPolicy = () => {
  return (
    <div className={styles.privacyPolicyPage}>
      <Container className={`sectionContainer`}>
        <Row className={styles.pageTitle}>
          <Col>
            <SectionTitle $textAlign="center">Privacy Policy</SectionTitle>
          </Col>
        </Row>

        {/* Section 1: Introduction */}
        <Row>
          <Col>
            <h3>Introduction</h3>
            <Text>
              We are committed to providing customers with exceptional service.
              Our commitment to exceptional service includes striving to maintain
              the accuracy and security of Personal Information.
            </Text>
          </Col>
        </Row>

        {/* Section 2: Scope of this Privacy Policy */}
        <Row>
          <Col>
            <h3>Scope of this Privacy Policy</h3>
            <Text>
              This Privacy Policy applies to Canco Petroleum Ltd. and each of
              its affiliates (collectively, "Canco"). In this Privacy Policy,
              "we", "us", "our" refers to Canco. This Privacy Policy applies to
              Personal Information that Canco collects, uses, or discloses.
              <br />
              <br />
              We are committed to protecting Personal Information in compliance
              with applicable privacy legislation, including the Personal
              Information Protection Act (British Columbia), the Personal
              Information Protection Act (Alberta), and the Personal Information
              Protection and Electronic Documents Act (Canada), as is appropriate
              in the circumstances.
            </Text>
          </Col>
        </Row>

        {/* Section 3: Definition of Personal Information */}
        <Row>
          <Col>
            <h3>Definition of Personal Information</h3>
            <Text>
              For the purposes of this Privacy Policy, "Personal Information"
              means information about an identifiable individual including without
              limitation an individual's name, home address, phone number, email
              address, or date of birth. Personal Information does not include
              information that would enable an individual to be contacted at a
              place of business, the name of a business entity, position or
              title, business telephone number, business address, business email
              or business fax number of an entity.
            </Text>
          </Col>
        </Row>

        {/* Section 4: Providing and Collecting Personal Information */}
        <Row>
          <Col>
            <h3>Providing and Collecting Personal Information</h3>
            <Text>
              An individual can voluntarily provide their Personal Information to
              us. We will only collect individuals' information to fulfill the
              purposes necessary for Canco's services or operations, including but
              not limited to the following:
              <ul className={styles.infoList}>
                <li>
                  <b>(a)</b> to enroll an individual in a loyalty program;
                </li>
                <li>
                  <b>(b)</b> to verify identity;
                </li>
                <li>
                  <b>(c)</b> to contact an individual;
                </li>
                <li>
                  <b>(d)</b> providing updates or informative communications
                  related to the programs, products or services an individual has
                  inquired about or interacted with;
                </li>
                <li>
                  <b>(e)</b> providing information to companies that provide
                  support services to us and that help us communicate to an
                  individual. These companies may use information about an
                  individual to perform their functions on our behalf; or
                </li>
                <li>
                  <b>(f)</b> to collect website usage information which may
                  involve the use of cookies.
                </li>
              </ul>
            </Text>
          </Col>
        </Row>

        {/* Section 5: Consent */}
        <Row>
          <Col>
            <h3>Consent</h3>
            <Text>
              Individuals' consent, whether implied or express, to collect, use or
              disclose Personal Information can be provided in writing,
              electronically, through an authorized representative, or it can be
              implied when permitted by applicable law.
              <br />
              <br />
              Individuals may withhold or withdraw their consent for us to
              collect, use or disclose their Personal Information in certain
              situations, subject to certain exceptions including without
              limitation in circumstances wherein Personal Information is
              necessary to provide a service or product, or a withdrawal of
              consent would frustrate the performance of a legal obligation.
              <br />
              <br />
              If an individual does not agree to the collection, use, disclosure
              or management of an individual's personal information in accordance
              with this Privacy Policy, an individual should not use this site.
            </Text>
          </Col>
        </Row>

        {/* Section 6: Using and Disclosing Personal Information */}
        <Row>
          <Col>
            <h3>Using and Disclosing Personal Information</h3>
            <Text>
              Canco will rely on express or implied consent from individuals as is
              appropriate in the given circumstances, to collect, use or disclose
              Personal Information for purposes applicable to its operations
              including without limitation:
              <ul className={styles.infoList}>
                <li>
                  <b>(a)</b> in the event of a merger, acquisition, financing, or
                  sale of assets or any other situation involving the transfer of
                  business assets;
                </li>
                <li>
                  <b>(b)</b> when sharing aggregated or anonymized information
                  that does not directly identify an individual for third-party
                  support services; or
                </li>
                <li>
                  <b>(c)</b> when providing information to companies that provide
                  support services to us (such as our loyalty program vendor) and
                  that help us communicate to individuals.
                </li>
              </ul>
            </Text>
          </Col>
        </Row>

        {/* Section 7: Cookies */}
        <Row>
          <Col>
            <h3>Cookies</h3>
            <Text>
              When an individual accesses our website, we may use a browser
              feature called a 'cookie' to collect information such as the type
              of Internet browser and operating system the individual uses, the
              domain name of the website from which the individual came, date and
              duration of the visit, number of visits, average time spent on our
              website, pages viewed and number of cookies accumulated. A cookie
              is a small text file containing a unique identification number that
              identifies the individual's browser, but not necessarily the
              individual, to our computers each time our website is visited.
              Unless an individual specifically informs us, we will not know who
              the individuals are.
              <br />
              <br />
              In addition to the identified purposes described in our Privacy
              Policy, we may use this website information and share it with other
              organizations with whom we have a commercial relationship to measure
              the use of our website, to improve the functionality and content of
              the website and to facilitate usage by an individual.
              <br />
              <br />
              Individuals can reset their browsers either to notify them when
              they have received a cookie or refuse to accept cookies. However,
              if an individual refuses to accept cookies, he or she may not be
              able to use some of the features available on our website.
            </Text>
          </Col>
        </Row>

        {/* Section 8: Data Storage */}
        <Row>
          <Col>
            <h3>Data Storage</h3>
            <Text>
              We are committed to ensuring the security of individuals' Personal
              Information in order to protect it from unauthorized access,
              collection, use, disclosure, copying, modification, or disposal or
              similar risks. The following security measures will be followed to
              ensure that individuals' Personal Information is appropriately
              protected:
              <ul className={styles.infoList}>
                <li>
                  <b>(a)</b> Physically securing offices where Personal
                  Information is held;
                </li>
                <li>
                  <b>(b)</b> The use of user IDs, passwords, encryption,
                  firewalls;
                </li>
                <li>
                  <b>(c)</b> Restricting employee access to Personal Information
                  as appropriate; and
                </li>
                <li>
                  <b>(d)</b> Contractually requiring service providers to provide
                  security measures.
                </li>
              </ul>
              <br />
              <br />
              Personal Information collected by Canco may be stored or processed
              outside of Canada, including in foreign jurisdictions such as the
              United States, and may be accessible to foreign courts, law
              enforcement, or government authorities under local or foreign laws.
              By using Canco's services or submitting Personal Information, an
              individual consents to the transfer, storage, and processing of
              their information outside their province or Canada, where it may be
              subject to different privacy laws.
              <br />
              <br />
              While we use contractual means to require service providers to
              provide certain levels of protection, Personal Information cannot be
              completely secure.
              <br />
              <br />
              In the event of a breach involving Personal Information that poses a
              real risk of significant harm, we will notify affected individuals
              and report the breach as required by applicable laws in Canada.
            </Text>
          </Col>
        </Row>

        {/* Section 9: Access to Personal Information */}
        <Row>
          <Col>
            <h3>Access to Personal Information</h3>
            <Text>
              Individuals have a right to access their Personal Information,
              subject to certain exceptions.
              <br />
              <br />
              A request to access Personal Information by an Individual must be
              made in writing and provide sufficient detail to identify the
              Personal Information being sought. A request to access Personal
              Information should be forwarded to Canco's privacy officer.
              <br />
              <br />
              A fee may be charged for providing access to Personal Information.
              Where a fee may apply, we will inform the individual of the cost and
              request further directions from the individual on whether or not we
              should proceed with the request.
              <br />
              <br />
              If a request is refused in full or in part, we will notify the
              individual in writing, providing the reasons for refusal and the
              recourse available to the individual, if any.
            </Text>
          </Col>
        </Row>

        {/* Section 10: Correction to Personal Information */}
        <Row>
          <Col>
            <h3>Correction to Personal Information</h3>
            <Text>
              Individuals may request correction to their Personal Information to
              ensure its accuracy and completeness. A request to correct Personal
              Information must be made in writing and provide sufficient detail
              to identify the Personal Information and the correction being
              sought. A request to correct Personal Information should be
              forwarded to Canco's Privacy Officer.
            </Text>
          </Col>
        </Row>

        {/* Section 11: Additional Information */}
        <Row>
          <Col>
            <Text>
              Upon request, we will also tell individuals how we use their
              Personal Information and to whom it has been disclosed, if
              applicable.
            </Text>
          </Col>
        </Row>

        {/* Section 12: Privacy Officer Contact */}
        <Row>
          <Col>
            <h3>Privacy Officer</h3>
            <Text>
              Canco Petroleum Ltd.
              <br />
              #200 – 125 Highway 33 East,
              <br />
              Kelowna, British Columbia V1X 2A1
              <br />
              <br />
              Individuals may send complaints, concerns, or questions regarding
              Personal Information by mail to the Privacy Officer.
            </Text>
          </Col>
        </Row>

        {/* Section 13: Amendments */}
        <Row>
          <Col>
            <h3>Amendments to this Privacy Policy</h3>
            <Text>
              Canco reserves the right to make changes to this Privacy Policy at
              its sole discretion at any time without notice to any individual or
              any other entity.
              <br />
              <br />
              By continuing to use this site after any updates, an individual
              acknowledges and agrees to the terms of the then current privacy
              policy.
              <br />
              <br />
              Changes to this Privacy Policy are effective when they are posted on
              this page.
              <br />
              <br />
              The collection, use and disclosure of any individual's Personal
              Information by Canco will be governed by the latest version of this
              Privacy Policy posted on this page.
            </Text>
          </Col>
        </Row>

        {/* Last Revised Date */}
        <Row>
          <Col>
            <Text style={{ marginTop: "3rem", fontStyle: "italic" }}>
              <b>Last revised:</b> November 18, 2025
            </Text>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;

